module.exports = __webpack_public_path__ + "static/media/house.56552075.svg";